export default __webpack_public_path__ + "static/media/bondly-eth-uni-closed-stub.674156dd.svg";